import React, { useState, useEffect } from "react";
import "../css/Login.css";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import Logo from "../assets/img/ThinkStore_Login.png";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [termsConditions, setTermsConditions] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        { email, password }
      );

      const { token, user } = response.data;

      setLoginData({ token, user });

      if (rememberMe) {
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));
      } else {
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("user", JSON.stringify(user));
      }

      proceedToDashboard(user, token);
    } catch (err) {
      showErrorToast(
        err.response?.data?.message || TOAST_MESSAGES.AUTH.LOGIN_FAILED
      );
    } finally {
      setLoading(false);
    }
  };

  const proceedToDashboard = async (user, token) => {
    try {
      showSuccessToast(TOAST_MESSAGES.AUTH.LOGIN_SUCCESS);

      const rolesResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/roles`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const roles = rolesResponse.data || [];
      const userRole = roles.find((role) => role.role_id === user.role_fid);

      if (userRole) {
        switch (userRole.role_name) {
          case "Superadmin":
            navigate("/superadmin/dashboard");
            break;
          case "Admin":
            navigate("/admin/dashboard");
            break;
          case "User":
            navigate("/user/dashboard");
            break;
          default:
            navigate("/dashboard");
        }
      } else {
        showErrorToast(TOAST_MESSAGES.AUTH.NO_ROLE);
        navigate("/dashboard");
      }
    } catch (error) {
      showErrorToast("Role fetch failed");
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        {/* <h2 className="title" >AI ThinkStore</h2> */}
        <div className="hidden md:block text-lg md:text-xl font-semibold textcolor">
          <img
            src={Logo}
            className="w-80 aspect-[3/1] object-contain"
            alt="Logo"
          />
        </div>
      </div>

      <div className="login-right d-flex flex-column align-items-start justify-content-center">
        <form
          className="login-form p-4 rounded-3 mt-3 mx-auto"
          onSubmit={handleLogin}
          style={{ maxWidth: "420px", width: "100%" }}
        >
          <div className="pb-3">
            <h3 className="mt-2 text-start fw-bold">Welcome back!</h3>
            <p className="text-start login-p">
              Please enter your details to sign in
            </p>
          </div>

          <div className=" w-100 mb-3">
            <p className="input-text">Email (Username)</p>
            <div className=" border-end rounded-end ">
              {/* <span className="input-group-text">
                <i className="bi bi-envelope-fill"></i>
              </span> */}
              <input
                type="email"
                className="form-control p-2"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className=" w-100 mb-2">
            <p className="input-text">Password</p>
            <div className="input-group">
              {/* <span className="input-group-text">
                <i className="bi bi-lock-fill"></i>
              </span> */}
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span
                className="input-group-text"
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword(!showPassword)}
              >
                <i
                  className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                ></i>
              </span>
            </div>
          </div>

          <div className="mb-4 d-flex justify-content-end">
            <Link
              to="/forgot-password"
              className="text-decoration-none small input-text mt-2"
            >
              Forgot Password?
            </Link>
          </div>

          <button type="submit" className="custom-btn w-100" disabled={loading}>
            {loading ? "Signing..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
